import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';
import { actionMotionStyles } from '../micro-interactions/actionMotion';
import { ButtonStyle } from './style';
export const PrimaryButon = ({ children, motion = false, disabled, onClick, mt = 0, mb = 0, type = 'button' }) => {
    // Prevent onClick when disabled
    const handleClick = (e) => {
        if (disabled) {
            e.preventDefault(); // Prevent click when disabled
            return;
        }
        if (onClick) {
            onClick(); // Trigger onClick if not disabled
        }
    };
    const theme = useTheme();
    return (_jsx(Box, { component: 'button', onClick: handleClick, width: '100%', mb: mb, type: type, sx: {
            ...ButtonStyle,
            ...(motion ? actionMotionStyles : {}),
            mt: `${mt}px`,
            background: disabled ? "#FDBCBC" : theme.palette.primary.main,
            border: disabled ? '1px solid #FDBCBC' : 'none',
            cursor: disabled ? 'not-allowed' : 'pointer',
        }, disabled: disabled, children: _jsx(Typography, { sx: { whiteSpace: 'nowrap' }, variant: 'subtitle2', color: theme.palette.primary.contrastText, children: children }) }));
};
